import Sentry from '../sentry';

export function error(err) {
  /* eslint-disable no-console */
  console.error(err);

  if (Sentry.getCurrentHub().getClient()) {
    if (err instanceof Error) {
      Sentry.captureException(err);
    } else {
      Sentry.captureException(new Error('Non-error object logged'), {
        extra: { originalError: err },
      });
    }
  }
  /* eslint-enable no-console */
}



// WEBPACK FOOTER //
// ./src/utils/logger.js